module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_onboard_instagram_dm-b4a7e69b76b424a9f4474510b9155d1d.svg";